import { render, staticRenderFns } from "./RetrieveWorkspaceURLPage.vue?vue&type=template&id=e51fb3da&scoped=true"
import script from "./RetrieveWorkspaceURLPage.vue?vue&type=script&lang=js"
export * from "./RetrieveWorkspaceURLPage.vue?vue&type=script&lang=js"
import style0 from "./RetrieveWorkspaceURLPage.vue?vue&type=style&index=0&id=e51fb3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51fb3da",
  null
  
)

export default component.exports